import React, { useEffect, useState } from 'react'
// import { Currencies } from '@orbital/games-frontend-library'
import { Play_content_props } from './interface'
import { ReactComponent as RedDiceSVG } from '../../../lib/assets/redDice.svg'
import { ReactComponent as BlueDiceSVG } from '../../../lib/assets/blueDice.svg'
import { Content } from '../../elements/button/ButtonStyles'
import AutoContent from './autoContent'
import { Currencies } from '../../../helpers/currency/getCurrencySymbol'
export default function PlayButtonContent({
  autoReady,
  autoRollNumber,
  rollUnder,
  finalStake,
  currency,
  startAuto,
  betCount,
  prec,
}: Play_content_props) {
  const [diceAnim, setdiceAnim] = useState<boolean>(false)

  useEffect(() => {
    setdiceAnim(true)
    const animtimeout = setTimeout(() => setdiceAnim(false), 300)
    return () => {
      clearTimeout(animtimeout)
    }
  }, [rollUnder])

  const PlayContent = (
    <>
      <p>Roll to win</p>
      <span>
        {Currencies[currency] && Currencies[currency].symbol}
        {finalStake > '0' ? (+finalStake).toFixed(prec) : '0.00'}
      </span>
    </>
  )

  const AutoRollContent = AutoContent(startAuto, autoRollNumber, betCount)

  return (
    <Content
      anim={diceAnim}
      className={autoRollNumber === '0' || autoRollNumber === '' ? 'auto' : ''}
    >
      {!autoReady ? PlayContent : AutoRollContent}
      {!rollUnder ? <RedDiceSVG /> : <BlueDiceSVG />}
    </Content>
  )
}
